<template>
  <div class="box body-bg">
    <div class="content">
      <div class="header">
        JSYDATA数据服务平台
      </div>
      <div class="login-box">
        <div class="login-con">
          <div class="info-box">
            <div class="row">
              <i class="icon icon-user"></i>
              <input type="text" v-model="username" placeholder="请输入账号" />
            </div>

            <div class="row">
              <i class="icon icon-pwd"></i>
              <input type="password" v-model="password" placeholder="请输入密码" />
            </div>

          </div>

          <a-button type="primary" class="btn" :loading="loading" @click="login">登录</a-button>

        </div>

      </div>
    </div>
    </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: null,
      password: null,
    };
  },
  methods: {
    login() {
      this.axios
        .post("/user/login", {
          username: this.username,
          password: this.password,
        })
        .then((response) => {
          if (response.data.success) {
            localStorage.setItem("token", response.data.msg);
            this.$router.push("/datasource");
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
  },
  created() {
    //bind login event to enter key
    document.onkeydown = (e) => {
      const key = window.event.keyCode;
      if (key == 13 || key == 100) {
        this.login();
      }
    };
  },
  destroyed() {
    //unbind login event to enter key when go to other pages
    document.onkeydown = null;
  },
};
</script>

<style lang="scss" scoped>
  .box {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
  }
  .body-bg {
    position: relative;
    height: 1080px;
    width: 100%;
    background-image: url(~@/images/login/bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .content {
    width: 100%;
    height: 100%;
    text-align: center;
    margin-top: 320px;
  }
  .header {
    font-size: 60px;
    font-family: DINPro;
    font-weight: bold;
    line-height: 82px;
    color: #00EAFF;
    letter-spacing: 15px;
  }
  .login-box {
    position: absolute;
    right: 170px;
    bottom: 100px;
    width: 618px;
    height: 573px;
    display: flex;
    justify-content: center;
    background-image: url(~@/images/login/login-box-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    .login-con {
      width: 418px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .info-box {
        .row {
          display: flex;
          padding: 10px 0;
          width: 418px;
          height: 61px;
          align-items: center;
          background: rgba(9,35,100,0.1300);
          border: 2px solid #00EAFF;

          &:first-child {
            margin-bottom: 68px;
          }

          .icon-user {
            width: 28px;
            height: 28px;
            margin-right: 20px;
            margin-left: 13px;
            background-image: url(~@/images/login/user.png);
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }

          .icon-pwd {
            width: 27px;
            height: 31px;
            margin-right: 24px;
            margin-left: 13px;
            background-image: url(~@/images/login/password.png);
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }

          input {
            flex: 1;
            border: unset;
            font-size: 20px;
            font-family: PingFang Regular;
            font-weight: 400;
            color: #ffffff!important;
            resize: none;
            background: none;
            /*border: none;*/
            height: 55px;
            outline: none;
            caret-color: #00EAFF;

            &::-webkit-input-placeholder {
              color: #c5c5c5;
            }
            input :focus {/* 去除获取焦点时的样式 */
              /*border: none;*/
              /*box-shadow: none;*/
              /*outline: none*/
            }
          }
        }

      }

      .btn {
        width: 100%;
        margin-top: 68px;
        border: unset;
        border-radius: 2px;
        font-size: 31px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 37px;
        color: #FFFFFF;
        letter-spacing: 20px;
        padding: 10px;
        cursor: pointer;

        /*height: 61px;*/
        /*border: 1px solid #00FFF6;*/
        background: linear-gradient(270deg, #6598FF 0%, #00EAFF 100%);
        box-shadow: 0px 9px 5px rgba(0,82,102,0.5900);
      }

      .buttton:hover {
        background-color: #00EAFF;
        font-size: 21px;
        cursor: pointer;
      }

    }
  }





</style>